import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { PaginatedPackageListViewList } from 'types';
import { client } from 'utils/api-client';

export default function useAffectedPackagesForEventType(
  eventTypeId: string | undefined,
): UseQueryResult<AxiosResponse<PaginatedPackageListViewList>> {
  return useQuery(
    ['packages', 'affectedByEventType', eventTypeId],
    () =>
      client.get('packages/', {
        params: {
          event_type: eventTypeId,
          is_archived: 'false',
          limit: '100',
        },
      }),
    {
      enabled: !!eventTypeId,
    },
  );
}
